import React from 'react'
import Image from 'next/image'
import { Container } from '../Container'
import { faShieldCheck } from '@fortawesome/pro-duotone-svg-icons/faShieldCheck'

import { LandingPageButton } from '../LandingPageButton'
import backgroundImage from '../../../public/img/nubrakes-van-house-800-num.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
export const ReviewPageTopSection: React.FC<{
  title: string
  description: string
}> = ({ title, description }) => {
  return (
    <section className="py-0">
      <div
        className="flex flex-col justify-center align-center"
        style={{ height: '60vh', position: 'relative', width: '100%' }}
      >
        <Image
          src={backgroundImage}
          placeholder="blur"
          layout={'fill'}
          objectFit="cover"
          objectPosition="bottom center"
          priority={true}
          alt="NuBrakes Reviews Header Image"
        />
        <div
          id="overlay"
          style={{
            minHeight: '100%',
            width: '100%',
            position: 'absolute',
            zIndex: 1,
            backgroundColor: 'rgba(0,0,0,.75)',
          }}
        />
        <div style={{ zIndex: 2 }}>
          <Container className="text-center">
            <div className='flex flex-col'>
              <h1 className="title text-white">{title}</h1>
              <p className={`description text-white`}>{description}</p>
              <LandingPageButton buttonText={'Get A Free Brake Repair Estimate'} />
              <div className='flex flex-row mt-4 gap-2 justify-center'>
                <FontAwesomeIcon icon={faShieldCheck} color={`#2D9CDB`} size={'2x'} />
                <p className={`description text-white`}>{"NuBrakes never offers incentives for reviews"}</p>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </section>
  )
}
